"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var libphonenumber_js_1 = require("libphonenumber-js");
/**
 * Returns a national formatted phone number as a string. If '+'
 * not found at beginning of string, will be added for you.
 * ie formatPhoneNumberToNational('+15162558538') === (516) 255-8538
 * ie formatPhoneNumberToNational('15162558538') === (516) 255-8538
 *
 * @param phoneNumber phone number string with the international area code
 */
exports.formatPhoneNumberToNational = function (phoneNumber) {
    return exports.generatePhoneNumberComponents(phoneNumber).formattedNationalNumber;
};
/**
 * Returns a international formatted phone number as a string. If '+'
 * not found at beginning of string, will be added for you.
 * ie formatPhoneNumberToNational('+15162558538') === +1 516 255 8538
 * ie formatPhoneNumberToNational('15162558538') === +1 516 255 8538
 *
 * @param phoneNumber phone number string with the international area code
 */
exports.formatPhoneNumberToInternational = function (phoneNumber) {
    return exports.generatePhoneNumberComponents(phoneNumber).formattedInternationalNumber;
};
/**
 * Returns a PhoneNumberProps object that contains phone number components.
 * If '+' not found at beginning of string, will be added for you.
 *
 * @param phoneNumber phone number string with the international area code
 */
exports.generatePhoneNumberComponents = function (phoneNumber) {
    var INTERNATIONAL_IDENTIFIER = '+';
    try {
        var internationalPhoneNumber = phoneNumber;
        if (internationalPhoneNumber.length >= 0 &&
            internationalPhoneNumber[0] !== INTERNATIONAL_IDENTIFIER) {
            internationalPhoneNumber = INTERNATIONAL_IDENTIFIER.concat(internationalPhoneNumber);
        }
        var parsedPhoneNumber = libphonenumber_js_1.default(internationalPhoneNumber);
        return {
            countryCode: parsedPhoneNumber.countryCallingCode,
            countryShortname: parsedPhoneNumber.country,
            internationalNumber: internationalPhoneNumber,
            formattedInternationalNumber: parsedPhoneNumber.formatInternational(),
            nationalNumber: parsedPhoneNumber.nationalNumber,
            formattedNationalNumber: parsedPhoneNumber.formatNational(),
        };
    }
    catch (e) {
        return {
            countryCode: undefined,
            countryShortname: undefined,
            internationalNumber: undefined,
            formattedInternationalNumber: undefined,
            nationalNumber: undefined,
            formattedNationalNumber: undefined,
        };
    }
};
